import { default as dataManipulation } from './dataManipulation';
import { default as effects } from './effects';
import { default as environment } from './environment';
import { default as general } from './general';
import { default as mouse } from './mouse';
import { default as polyfills } from './polyfills';
import { default as resize } from './resize';
import { default as shapes } from './shapes';


export default {
  dataManipulation,
  effects,
  environment,
  general,
  mouse,
  polyfills,
  resize,
  shapes,
};


/** WEBPACK FOOTER **
 ** ./src/core/utils/index.js
 **/